import {
  FETCH_ALL_ORGANIZATION_MEMBER_BOOKINGS,
  ADD_ORGANIZATION_MEMBER_BOOKING,
} from './../../mutation-types';

export default {
  [FETCH_ALL_ORGANIZATION_MEMBER_BOOKINGS](state, organizationMemberBookings) {
    state.all = organizationMemberBookings;
  },
  [ADD_ORGANIZATION_MEMBER_BOOKING](state, organizationMemberBooking) {
    state.all.unshift(organizationMemberBooking);
  },
};



// WEBPACK FOOTER //
// ./src/app/store/modules/organizationMemberBooking/mutations.js